import { r as registerInstance, h } from './index-506c059e.js';

const spinnerCss = ":host{display:inline-block}:host,:host *{-webkit-box-sizing:border-box;box-sizing:border-box}.spinner{position:relative}.spinner__layer-one{position:absolute;border-radius:50%;z-index:1}.spinner__layer-two{position:absolute;-webkit-transform:rotate(45deg);transform:rotate(45deg);border-radius:50%;z-index:2}.spinner--indeterminate{-webkit-animation:spin 2s linear infinite;animation:spin 2s linear infinite}@-webkit-keyframes spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}";
const PichinchaSpinnerStyle0 = spinnerCss;

const Spinner = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.backgroundColor = undefined;
        this.progressColor = 'bp-primary-yellow500';
        this.size = 100;
        this.borderWidth = 4;
        this.percentage = '50%';
        this.indeterminate = true;
    }
    get getSpinnerStyle() {
        const progressBorder = `${this.borderWidth}px solid var(--${this.progressColor})`;
        const backgroundBorder = `${this.borderWidth}px solid transparent`;
        let borderTop = backgroundBorder;
        let borderLeft = backgroundBorder;
        let borderRight = backgroundBorder;
        let borderBottom = backgroundBorder;
        switch (this.percentage) {
            case '25%':
                borderTop = progressBorder;
                break;
            case '50%':
                borderTop = progressBorder;
                borderRight = progressBorder;
                break;
            case '75%':
                borderTop = progressBorder;
                borderRight = progressBorder;
                borderBottom = progressBorder;
                break;
            case '100%':
                borderTop = progressBorder;
                borderRight = progressBorder;
                borderBottom = progressBorder;
                borderLeft = progressBorder;
        }
        return {
            borderTop,
            borderLeft,
            borderRight,
            borderBottom,
        };
    }
    get getWidth() {
        return {
            width: `${this.size}px`,
            height: `${this.size}px`,
        };
    }
    render() {
        return (h("div", { key: '6b7eb3d96a56e517f4143bd50c3b189709e7bba7', class: "spinner", style: Object.assign({}, this.getWidth) }, h("div", { key: '736d1d8f8e843353bd44a7f45d4991440dfb1b11', style: Object.assign(Object.assign(Object.assign({}, this.getSpinnerStyle), this.getWidth), { border: `${this.borderWidth}px solid var(--bp-grayScale50)`, backgroundColor: this.backgroundColor
                    ? `var(--${this.backgroundColor})`
                    : 'transparent' }), class: "spinner__layer-one" }), h("div", { key: '1771bd6741a3a18f64e903f223b6aa921e1da5be', class: 'spinner__layer-two' +
                (this.indeterminate ? ' spinner--indeterminate' : ''), style: Object.assign(Object.assign(Object.assign({}, this.getSpinnerStyle), this.getWidth), { backgroundColor: 'transparent' }) })));
    }
};
Spinner.style = PichinchaSpinnerStyle0;

export { Spinner as pichincha_spinner };
